
import Vue from 'vue'
import Router from 'vue-router'

import i18n from './i18n/i18n'

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          redirect: "/dashboard",
        },
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("./views/Dashboard.vue"),
          meta: {
            rule: "isBoth",
            authRequired: true,
          },
        },

        // =============================================================================
        // Cash Book Routes
        // =============================================================================

        {
          path: "/cashbook/:cashbookType",
          name: "cash-book",
          component: () => import("./views/cashbooks/Index.vue"),
          meta: {
            rule: "isBoth",
            authRequired: true,
          },
        },

        {
          path: "/cashbook/:cashbookType/cashflows/:cashbookId",
          name: "cash-book-cashflows",
          component: () => import("./views/cashflows/Index.vue"),
          meta: {
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              { title: i18n.t("CashBook"), active: true },
            ],

            pageTitle: i18n.t("CashBook"),
            rule: "isBoth",
            authRequired: true,
          },
        },

        {
          path: "/cashbook/:cashbookType/cashflows/:cashbookId/add",
          name: "cash-book-cashflows-add",
          component: () => import("./views/cashflows/Add.vue"),
          meta: {
            parent: "cash-book",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              { title: i18n.t("CashBook"), url: "/cash-book" },
              { title: i18n.t("CashBookAdd"), active: true },
            ],
            pageTitle: i18n.t("CashBook"),
            rule: "isBoth",
          },
        },

        {
          path: "/cashbook/:cashbookType/cashflows/edit/:id",
          name: "cash-book-cashflows-edit",
          component: () => import("./views/cashflows/Edit.vue"),
          meta: {
            parent: "cash-book",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              { title: i18n.t("CashBook"), url: "/cash-book" },
              { title: i18n.t("CashBookEdit"), active: true },
            ],
            pageTitle: i18n.t("CashBook"),
            rule: "isBoth",
          },
        },

        // =============================================================================
        // Cash Book Temporary Routes
        // =============================================================================

        {
          path: "/cash-book-temporary",
          name: "cash-book-temporary",
          component: () => import("./views/cashbooks-temporary/Index.vue"),
          meta: {
            rule: "isBoth",
            authRequired: true,
          },
        },
        {
          path: "/cash-book-temporary/add",
          name: "cash-book-temporary-add",
          component: () => import("./views/cashbooks-temporary/Add.vue"),
          meta: {
            parent: "cash-book-temporary",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              {
                title: i18n.t("CashBookTemporary"),
                url: "/cash-book-temporary",
              },
              { title: i18n.t("CashBookTemporaryAdd"), active: true },
            ],
            pageTitle: i18n.t("CashBookTemporary"),
            rule: "isBoth",
          },
        },
        {
          path: "/cash-book-temporary/edit/:id",
          name: "cash-book-temporary-edit",
          component: () => import("./views/cashbooks-temporary/Edit.vue"),
          meta: {
            parent: "cash-book-temporary",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              {
                title: i18n.t("CashBookTemporary"),
                url: "/cash-book-temporary",
              },
              { title: i18n.t("CashBookTemporaryEdit"), active: true },
            ],
            pageTitle: i18n.t("CashBookTemporary"),
            rule: "isBoth",
          },
        },
        {
          path: "/cash-book-temporary/detail/:id",
          name: "cash-book-temporary-detail",
          component: () => import("./views/cashbooks-temporary/Detail.vue"),
          meta: {
            parent: "cash-book-temporary",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              {
                title: i18n.t("CashBookTemporary"),
                url: "/cash-book-temporary",
              },
              { title: i18n.t("CashBookTemporaryDetail"), active: true },
            ],
            pageTitle: i18n.t("CashBookTemporary"),
            rule: "isBoth",
          },
        },

        // =============================================================================
        // Bank Routes
        // =============================================================================

        {
          path: "/bank",
          name: "bank",
          component: () => import("./views/bank/Index.vue"),
          meta: {
            rule: "isBoth",
            authRequired: true,
          },
        },
        {
          path: "/bank-account/detail/:id",
          name: "bank-account-detail",
          component: () => import("./views/bank-account/Index.vue"),
          meta: {
            parent: "bank",
            rule: "isBoth",
            authRequired: true,
          },
        },

        // =============================================================================
        // Bank Account Cashflow Routes
        // =============================================================================

        {
          path: "/bank-account-cashflow/:id",
          name: "bank-account-cashflow",
          component: () => import("./views/bank-account-cashflow/Index.vue"),
          meta: {
            parent: "bank",
            rule: "isBoth",
            authRequired: true,
          },
        },
        {
          path: "/bank-account-cashflow/add/:id",
          name: "bank-account-cashflow-add",
          component: () => import("./views/bank-account-cashflow/Add.vue"),
          meta: {
            parent: "bank",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              { title: i18n.t("Bank"), url: "/bank" },
              { title: i18n.t("BankAccountCashflowAdd"), active: true },
            ],
            pageTitle: i18n.t("BankAccountCashflow"),
            rule: "isBoth",
            authRequired: true,
          },
        },
        {
          path: "/bank-account-cashflow/edit/:id",
          name: "bank-account-cashflow-edit",
          component: () => import("./views/bank-account-cashflow/Edit.vue"),
          meta: {
            parent: "bank",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              { title: i18n.t("Bank"), url: "/bank" },
              { title: i18n.t("BankAccountCashflowEdit"), active: true },
            ],
            pageTitle: i18n.t("BankAccountCashflow"),
            rule: "isBoth",
            authRequired: true,
          },
        },

        // =============================================================================
        // Users Routes
        // =============================================================================

        {
          path: "/users",
          name: "users",
          component: () => import("./views/users/Index.vue"),
          meta: {
            rule: "isAdmin",
            authRequired: true,
          },
        },
        {
          path: "/users/add",
          name: "users-add",
          component: () => import("./views/users/Add.vue"),
          meta: {
            parent: "users",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              { title: i18n.t("User"), url: "/users" },
              { title: i18n.t("UserAdd"), active: true },
            ],
            pageTitle: i18n.t("UserAdd"),
            rule: "isAdmin",
          },
        },
        {
          path: "/users/edit/:id",
          name: "users-edit",
          component: () => import("./views/users/Edit.vue"),
          meta: {
            parent: "users",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              { title: i18n.t("User"), url: "/users" },
              { title: i18n.t("UserEdit"), active: true },
            ],
            pageTitle: i18n.t("UserEdit"),
            rule: "isAdmin",
          },
        },
        {
          path: "/users/detail/:id",
          name: "users-detail",
          component: () => import("./views/users/Detail.vue"),
          meta: {
            parent: "users",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              { title: i18n.t("User"), url: "/users" },
              { title: i18n.t("UserDetail"), active: true },
            ],
            pageTitle: i18n.t("UserDetail"),
            rule: "isAdmin",
          },
        },
        // =============================================================================
        // Company Routes
        // =============================================================================

        {
          path: "/company",
          name: "company",
          component: () => import("./views/company/Index.vue"),
          meta: {
            rule: "isAdmin",
            authRequired: true,
          },
        },
        {
          path: "/company/add",
          name: "company-add",
          component: () => import("./views/company/Add.vue"),
          meta: {
            parent: "company",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              { title: i18n.t("Company"), url: "/company" },
              { title: i18n.t("CompanyAdd"), active: true },
            ],
            pageTitle: i18n.t("CompanyAdd"),
            rule: "isAdmin",
          },
        },
        {
          path: "/company/edit/:id",
          name: "company-edit",
          component: () => import("./views/company/Edit.vue"),
          meta: {
            parent: "company",
            breadcrumb: [
              { title: i18n.t("Dashboard"), url: "/dashboard" },
              { title: i18n.t("Company"), url: "/company" },
              { title: i18n.t("CompanyEdit"), active: true },
            ],
            pageTitle: i18n.t("CompanyEdit"),
            rule: "isAdmin",
          },
        },
        {
          path: "/company-accounts",
          name: "company-accounts",
          component: () => import("./views/settings/Company.vue"),
          meta: {
            parent: "company",
            breadcrumb: [
              { title: i18n.t("Settings"), url: "/dashboard" },
              { title: i18n.t("CompanyAccount"), active: true },
            ],
            pageTitle: i18n.t("CompanyAccount"),
            rule: "isBoth",
          },
        },

        {
          path: "/profile",
          name: "profile",
          component: () => import("./views/settings/Profile.vue"),
          meta: {
            breadcrumb: [
              { title: i18n.t("Settings"), url: "/dashboard" },
              { title: i18n.t("Profile"), active: true },
            ],
            pageTitle: i18n.t("Profile"),
            rule: "isBoth",
          },
        },

        // =============================================================================
        // Pages Routes
        // =============================================================================
        {
          path: "/pages/profile",
          name: "page-profile",
          component: () => import("@/views/pages/Profile.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Pages" },
              { title: "Profile", active: true },
            ],
            pageTitle: "Profile",
            rule: "isBoth",
          },
        },
        {
          path: "/pages/user-settings",
          name: "page-user-settings",
          component: () =>
            import("@/views/pages/user-settings/UserSettings.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Pages" },
              { title: "User Settings", active: true },
            ],
            pageTitle: "Settings",
            rule: "isBoth",
          },
        },
      ],
    },

    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/callback",
          name: "auth-callback",
          component: () => import("@/views/Callback.vue"),
          meta: {
            rule: "isBoth",
          },
        },
        {
          path: "/login",
          name: "login",
          component: () => import("@/views/auth/login/Login.vue"),
          meta: {
            rule: "isBoth",
          },
        },
        {
          path: "/register",
          name: "register",
          component: () => import("@/views/auth/register/Register.vue"),
          meta: {
            rule: "isAdmin",
          },
        },
        {
          path: "/forgot-password",
          name: "forgot-password",
          component: () => import("@/views/auth/ForgotPassword.vue"),
          meta: {
            rule: "isBoth",
          },
        },
        {
          path: "/reset-password",
          name: "reset-password",
          component: () => import("@/views/auth/ResetPassword.vue"),
          meta: {
            rule: "isBoth",
          },
        },
        {
          path: "/lock-screen",
          name: "lock-screen",
          component: () => import("@/views/auth/LockScreen.vue"),
          meta: {
            rule: "isBoth",
          },
        },
        {
          path: "/pages/comingsoon",
          name: "page-coming-soon",
          component: () => import("@/views/pages/ComingSoon.vue"),
          meta: {
            rule: "isBoth",
          },
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            rule: "isBoth",
          },
        },
        {
          path: "/pages/error-500",
          name: "page-error-500",
          component: () => import("@/views/pages/Error500.vue"),
          meta: {
            rule: "isBoth",
          },
        },
        {
          path: "/pages/not-authorized",
          name: "page-not-authorized",
          component: () => import("@/views/pages/NotAuthorized.vue"),
          meta: {
            rule: "isBoth",
          },
        },
        {
          path: "/pages/maintenance",
          name: "page-maintenance",
          component: () => import("@/views/pages/Maintenance.vue"),
          meta: {
            rule: "isBoth",
          },
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("accessToken");

  if (to.meta.authRequired) {
    if (!loggedIn) {
      router.push({ path: "/login" });
    }
  }
  return next();
});

export default router
